import { createQueryKeyFactory } from '@/utils/queries'

const userQueryKeys = createQueryKeyFactory(['users'])

export default {
    ...userQueryKeys,
}
